import React from 'react';
import { Box } from '@mui/material';
import { colors } from 'theme/colors';
import PersonalDataStep from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/PersonalDataStep';
import PersonalHealthStep from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/PersonalHealthStep';
import ShotgunDetailsStep from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/ShotgunDetailsStep';
import RefereeDetailsStep from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/RefereeDetailsStep';
import OffencesStep from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/OffencesStep';
import AttachmentsStep from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/AttachmentsStep';
import DeclarationStep from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/DeclarationStep';

interface IApplyOnlineWizardStep {
  activeStep: number;
  submitCaller: null | number;
  setNextStep: () => void;
}

interface ISteps {
  submitCaller: null | number;
  setNextStep: () => void;
}

const ApplyOnlineWizardStep = ({
  activeStep,
  submitCaller,
  setNextStep,
}: IApplyOnlineWizardStep) => {
  const steps: React.ComponentType<ISteps>[] = [
    PersonalDataStep,
    PersonalHealthStep,
    ShotgunDetailsStep,
    RefereeDetailsStep,
    OffencesStep,
    AttachmentsStep,
    DeclarationStep,
  ];

  const isValidStep = activeStep >= 0 && activeStep <= steps.length;
  const StepComponent = isValidStep ? steps[activeStep] : null;

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: 'calc(100vh - 212px)',
        flexDirection: 'column',
        padding: '40px 64px',
        background: `${colors.blue50}`,
        alignItems: 'center',
      }}
    >
      <div style={{ maxWidth: '1000px' }}>
        {StepComponent ? (
          <StepComponent submitCaller={submitCaller} setNextStep={setNextStep} />
        ) : null}
      </div>
    </Box>
  );
};

export { ApplyOnlineWizardStep };
